'use client';

import { cn } from '@/lib/utils';

type ReadMoreBtnProps = {
  isExpanded: boolean;
  expandedText?: string;
  collapsedText?: string;
  onClick: () => void;
  className?: string;
};

export default function ReadMoreBtn({
  isExpanded,
  expandedText = 'Read less',
  collapsedText = 'Read more',
  onClick,
  className,
}: ReadMoreBtnProps) {
  return (
    <button
      className={cn('font-semibold text-brand-dark hover:underline', className)}
      onClick={onClick}
    >
      {isExpanded ? expandedText : collapsedText}
    </button>
  );
}
